import { render, staticRenderFns } from "./EditChangelog.vue?vue&type=template&id=2f2e5b4a&"
import script from "./EditChangelog.vue?vue&type=script&lang=ts&"
export * from "./EditChangelog.vue?vue&type=script&lang=ts&"
import style0 from "./EditChangelog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports